var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.25C1 15.2337 2.18526 18.0952 4.29505 20.205C6.40483 22.3147 9.26631 23.5 12.25 23.5C15.2337 23.5 18.0952 22.3147 20.205 20.205C22.3147 18.0952 23.5 15.2337 23.5 12.25C23.5 9.26631 22.3147 6.40483 20.205 4.29505C18.0952 2.18526 15.2337 1 12.25 1C9.26631 1 6.40483 2.18526 4.29505 4.29505C2.18526 6.40483 1 9.26631 1 12.25V12.25Z",
    stroke: "#5928E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.539 23.1711C8.017 20.9391 7 16.8831 7 12.2501C7 7.6171 8.017 3.5611 9.539 1.3291",
    stroke: "#5928E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.25H23.5",
    stroke: "#5928E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.73193 18.25H21.7679",
    stroke: "#5928E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.73193 6.25H21.7679",
    stroke: "#5928E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9609 1.3291C16.4829 3.5611 17.4999 7.6171 17.4999 12.2501C17.4999 16.8831 16.4829 20.9391 14.9609 23.1711",
    stroke: "#5928E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.8707c87612d4aa4a03ebc4376ef4d750.svg";
export { ForwardRef as ReactComponent };